<script>
  import { doLoading } from "../../Api/congress_stores.js";
  import tippy from "sveltejs-tippy";
  import { createEventDispatcher } from "svelte";

  export let veranstaltungId = 0;
  export let tnHasKongress = 0;
  export let timeslot;
  export let anmeldestop = false;

  const dispatch = createEventDispatcher();
  const alreadyBooked = "Nicht verfügbar - Sie sind schon zu einer anderen Veranstaltung zum selben Zeitpunkt angemeldet.";
  const notRegistred = tnHasKongress != 1 ? "Sie sind nicht für diesen Kongress angemeldet." : false;
  const noBookingsPossible = "Es sind keine Anmeldungen mehr möglich";

  doLoading.subscribe((value) => {
    showLoading = value;
  });

  function processBookingAction(actionType) {
    doLoading.update(() => true);

    // Check if the user is registered for the congress
    if (actionType.startsWith("booking") && notRegistred) {
      alert(notRegistred);
      doLoading.update(() => false);
      return;
    }

    dispatch("booking", { actionType, actionId: veranstaltungId, actionBlocknumber: timeslot.blocknumber });
  }
</script>

{#if timeslot.status == 1}
  <td class="border-l border-t !border-l-black/50 p-0">
    {#if anmeldestop}
      <span class="block w-full cursor-not-allowed bg-green-700 px-1 py-2 text-white opacity-80" aria-label={noBookingsPossible} use:tippy={{ content: noBookingsPossible }} />
    {:else if notRegistred}
      <span class="block w-full cursor-not-allowed bg-green-700 px-1 py-2 text-white opacity-80" aria-label={notRegistred} use:tippy={{ content: notRegistred }}>Buchen</span>
    {:else}
      <button class="block w-full bg-green-700 px-1 py-2 text-white hocus:bg-green-800" on:click={() => processBookingAction("bookingoo")}>Buchen</button>
    {/if}
  </td>
{:else if timeslot.status == -1}
  <td class="cursor-help border-l border-t !border-l-black/50 bg-gray-100/50 px-1 py-2" aria-label={alreadyBooked} use:tippy={{ content: alreadyBooked }}>n.v.</td>
{:else}
  <td class="cursor-not-allowed border-l border-t !border-l-black/50 bg-red-200 px-1 py-2">Belegt</td>
{/if}
